webpackJsonp([2],{

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(23);

var _styledComponents = __webpack_require__(47);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrivacyStyles = _styledComponents2.default.div.withConfig({
  displayName: 'Privacy_policy__PrivacyStyles',
  componentId: 'sc-1n4o06k-0'
})(['a{display:inline;}']);

exports.default = function () {
  return _react2.default.createElement(
    PrivacyStyles,
    null,
    _react2.default.createElement(_reactStatic.Head, {
      title: 'privacy policy',
      meta: [{ name: "description", content: 'this is privacy policy of this website.' }, { property: "og:title", content: "privacy policy | Ryoji Hayasaka Portfolio" }, { property: "og:description", content: 'this is privacy policy of this website.' }, { property: "og:image", content: "https://secure.gravatar.com/avatar/301071becdd1890fa7078cbe29ce83ba?s=400" }, { property: "og:url", content: 'https://hyks.jp/privacy_policy' }, { property: "og:type", content: "article" }]
    }),
    _react2.default.createElement(
      'h1',
      null,
      'privacy policy'
    ),
    _react2.default.createElement(
      'h2',
      null,
      'Purpose of using personal information'
    ),
    _react2.default.createElement(
      'p',
      null,
      'This website includes Google Analytics, collects your access data which does not enable the identification of the specific individual. Google Analytics uses Cookie in order to collect your access data. You can refuse this behavior by disabling Cookie.',
      _react2.default.createElement('br', null),
      'For details on this policy, please click ',
      _react2.default.createElement(
        _reactStatic.Link,
        { to: 'https://www.google.com/analytics/terms/' },
        'HERE'
      ),
      '.'
    )
  );
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Privacy_policy.f7824509.js